var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EntityCard',{attrs:{"title":_vm.itemGroup.label,"show-icon":"","icon-url":_vm.iconUrl},on:{"click":_vm.showItemGroup}})
}
var staticRenderFns = []

export { render, staticRenderFns }